(() => {
  const script = document.querySelector('script[data-ff-shopping-context]');
  const key = 'ff:shopping-origin:v2:' + (script?.dataset.ffThemeId || 'storefront');
  const maxAge = 2 * 60 * 60 * 1000;

  const parseUrl = (value) => {
    try {
      return value ? new URL(value, window.location.origin) : null;
    } catch {
      return null;
    }
  };

  const isBrowsing = (url) => {
    if (!url || url.origin !== window.location.origin) return false;
    return url.pathname === '/' || url.pathname === '/search' ||
      /^\/collections\/[^/]+(?:\/[^/]+)?\/?$/.test(url.pathname);
  };

  const isProduct = (url) =>
    url?.origin === window.location.origin && /^\/products\/[^/]+\/?$/.test(url.pathname);

  const readOrigin = () => {
    try {
      const record = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (!record || typeof record.savedAt !== 'number' ||
          record.savedAt > Date.now() || Date.now() - record.savedAt > maxAge) return null;
      const url = parseUrl(record.url);
      if (!isBrowsing(url)) return null;
      return {
        url,
        productPath: typeof record.productPath === 'string' ? record.productPath : null
      };
    } catch {
      return null;
    }
  };

  const remember = (url, productPath = null) => {
    if (!isBrowsing(url)) return;
    try {
      sessionStorage.setItem(key, JSON.stringify({
        url: url.href,
        productPath,
        savedAt: Date.now()
      }));
    } catch {
      return;
    }
  };

  const currentUrl = () => new URL(window.location.href);
  const initial = currentUrl();

  if (isBrowsing(initial)) {
    let productSelected = false;
    remember(initial);

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      if (event.button !== 0 || event.metaKey || event.ctrlKey ||
          event.shiftKey || event.altKey) return;
      const anchor = event.target.closest('a[href]');
      if (!anchor) return;
      const productUrl = parseUrl(anchor.href);
      if (!isProduct(productUrl)) return;

      const source = currentUrl();
      const card = anchor.closest('product-card');
      if (card) {
        const page = card.closest('.product-grid__item[data-page]')?.dataset.page;
        if (/^\/collections\//.test(source.pathname) && /^\d+$/.test(page || '')) {
          source.searchParams.set('page', page);
        }
        const productAnchor = card.querySelector('.product-card__link[id]');
        if (productAnchor?.id) source.hash = productAnchor.id;
      }

      productSelected = true;
      remember(source, productUrl.pathname);
    }, true);

    window.addEventListener('pagehide', () => {
      if (!productSelected) remember(currentUrl());
    });

    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        productSelected = false;
        remember(currentUrl());
      }
    });
  } else if (isProduct(initial)) {
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      if (event.button !== 0 || event.metaKey || event.ctrlKey ||
          event.shiftKey || event.altKey) return;
      const anchor = event.target.closest('a[href]');
      const nextProduct = parseUrl(anchor?.href);
      if (!isProduct(nextProduct)) return;
      const origin = readOrigin();
      if (origin?.productPath === currentUrl().pathname) {
        remember(origin.url, nextProduct.pathname);
      }
    }, true);
  }

  const returnDestination = () => {
    const here = currentUrl();
    if (isBrowsing(here)) return here;

    const origin = readOrigin();
    if (isProduct(here) && origin?.productPath === here.pathname) return origin.url;

    const referrer = parseUrl(document.referrer);
    if (isBrowsing(referrer)) return referrer;

    if (here.pathname === '/cart' && origin) return origin.url;
    return null;
  };

  const updateLinks = () => {
    const destination = returnDestination();
    if (!destination) return;
    document.querySelectorAll('a[data-ff-continue-shopping]').forEach((link) => {
      link.href = destination.href;
    });
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[data-ff-continue-shopping]');
    if (!link) return;

    const destination = returnDestination();
    if (!destination) return;
    link.href = destination.href;

    if (event.defaultPrevented || event.button !== 0 || event.metaKey ||
        event.ctrlKey || event.shiftKey || event.altKey) return;

    event.preventDefault();
    if (isBrowsing(currentUrl()) && link.closest('#cart-drawer')) {
      document.getElementById('cart-drawer')?.close();
      return;
    }

    const drawer = link.closest('#cart-drawer');
    if (drawer && typeof drawer.close === 'function') {
      Promise.resolve(drawer.close())
        .catch(() => {})
        .then(() => window.location.assign(destination.href));
    } else {
      window.location.assign(destination.href);
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateLinks, { once: true });
  } else {
    updateLinks();
  }

  const cartDrawer = document.getElementById('cart-drawer');
  if (cartDrawer) {
    new MutationObserver(updateLinks).observe(cartDrawer, { childList: true, subtree: true });
  }
  document.addEventListener('theme-drawer:open', updateLinks);
})();